<template>
  <div class="page-profile" style="position: relative;">

    <div class="flex">
      <div class="avatar" v-if="user">
        <div class="edit-hover">
          <span>Edit</span>
        </div>
        <div class="remove-hover" @click="removeAvatar" v-if="user.avatarPath">
          <span class="el-icon-delete"></span>
        </div>
        <div class="avatar-upload" v-show="!edit">
          <div class="text-center">
            <label for="avatar">
              <img
                :src="files.length ? files[0].url : ''"
                v-if="files.length || user.avatarPath"
                class="rounded-circle"
              />
              <span
                class="contact-avatar"
                v-else-if="user.hasOwnProperty('myExtension')"
              >
                {{ user.myExtension.name.substring(0, 1).toUpperCase() }}
              </span>
            </label>
          </div>
          <div class="text-center p-2">
            <file-upload
              extensions="gif,jpg,jpeg,png,webp"
              accept="image/png,image/gif,image/jpeg,image/webp"
              name="avatar"
              class="btn btn-primary"
              :custom-action="uploadAvatar"
              :drop="!edit"
              v-model="files"
              @input-filter="inputFilter"
              @input-file="inputFile"
              ref="upload"
            />
          </div>
        </div>
        <div class="avatar-edit" v-show="files.length && edit">
          <div class="avatar-edit-image" v-if="files.length">
            <img ref="editImage" :src="files[0].url" />
          </div>
          <div class="text-center p-4">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="$refs.upload.clear"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" @click.prevent="editSave">
              Save
            </button>
          </div>
        </div>
      </div>

      <div class="user-info">
        <div class="username">
          <span> {{ user ? user.myExtension.name : 'User'}}</span>
        </div>
        <div class="email">
          <span> {{ user ? user.email : '' }}</span>
        </div>
        <div class="extension">
          <span> {{ user ? `Ext: ${user.myExtension.number}` : ''}} </span>
        </div>
        <div class="direct-dials">
          <span v-for="(item, index) in userDirectDials" :key="item">
              {{ numberFormatter(item) }}
              {{ index === userDirectDials.length - 1 ? "" : ", " }}
            </span>
        </div>
      </div>

      <div class="softphone-toggle">
        <el-tooltip
          placement="bottom"
          :content="
          softphoneEnabled
            ? 'Softphone Enabled'
            : softphoneLocked
            ? 'Network Connection Lost'
            : 'Softphone Disabled'
        "
          v-if="userHasExtension && !mobileDevice"
        >
          <el-button
            id="devices-dropdown-toolbar"
            size="mini"
            @click="toggleSoftphoneEnabled"
            :disabled="softphoneLocked"
            style="box-shadow: none;"
          >
            <v-svg
              :class="
              softphoneEnabled
                ? 'voxo-green'
                : softphoneLocked
                ? 'voxo-dark-red'
                : 'icon-muted'
            "
              sprite="headset"
            />
          </el-button>
        </el-tooltip>
        <el-popover
          placement="left-start"
          trigger="click"
          v-show="softphoneEnabled"
          @show="queryAudioDevices"
          popper-class="devicePopper"
        >
          <div class="dropdown-icon" slot="reference">
            <v-svg sprite="chevron-down"></v-svg>
          </div>
          <el-form class="form-modal">
            <el-select
              v-model="selectedAudioDevice"
              v-if="inputDevices.length"
              v-loading="devicesLoading"
              placeholder="Select Audio Device"
              @change="changeAudioInput"
            >
              <template slot="prefix">Audio Device</template>
              <el-option
                v-for="(item, index) in inputDevices"
                :key="index"
                :value="item.deviceId"
                :label="item.label"
              />
            </el-select>
          </el-form>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { hostServer } from "@/feathers/feathers-client";
import feathersClient from "@/feathers/feathers-client";
import { isMobileDevice } from "@/globals/globals";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import "cropperjs/src/css/cropper.css";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "Profile",
  data() {
    return {
      activeTab: "My Profile",
      files: [],
      edit: false,
      cropper: false,
      selectedAudioDevice: '',
      inputDevices: [],
      devicesLoading: false
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    userDirectDials() {
      if (this.user) {
        return this.user.myExtension ? this.user.myExtension.directDials : [];
      }
    },
    softphoneEnabled(){
      return this.$store.state.softphoneEnabled;
    },
    softphoneLocked() {
      return this.$store.state.softphoneLocked;
    },
    userHasExtension() {
      if (this.user) {
        return !!this.user.myExtension;
      }
      return false;
    },
    audioInputDevice() {
      const fromStore = this.$store.state.audioInputDeviceId;
      const fromList = this.inputDevices;

      if (fromList.length) {
        if (!fromStore) {
          this.$store.commit("setAudioInputDeviceId", fromList[0].deviceId);
        }

        let foundMatch = false;
        if (fromStore) {
          for (let i = 0; i < fromList.length; i++) {
            if (fromList[i].deviceId === fromStore) {
              foundMatch = true;
              break;
            }
          }
          if (foundMatch) {
            this.selectedAudioDevice = fromStore;
            return fromStore;
          }
        } else {
          this.selectedAudioDevice = fromList[0].deviceId;
          return fromList[0].deviceId;
        }

        this.selectedAudioDevice = foundMatch
          ? fromStore
          : fromList[0].deviceId;
        return foundMatch ? fromStore : fromList[0].deviceId;
      }
      return null;
    },
    mobileDevice() {
      return isMobileDevice();
    },
  },
  watch: {
    user() {
      if (this.user.avatarPath) {
        this.files.push({ url: this.user.avatarPath });
      }
    },
    edit(value) {
      if (value) {
        this.$nextTick(function() {
          if (!this.$refs.editImage) {
            return;
          }
          let cropper = new Cropper(this.$refs.editImage, {
            aspectRatio: 1 / 1,
            viewMode: 1
          });
          this.cropper = cropper;
        });
      } else {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = false;
        }
      }
    }
  },
  methods: {
    editSave() {
      this.edit = false;
      let oldFile = this.files[0];
      let binStr = atob(
        this.cropper
          .getCroppedCanvas()
          .toDataURL(oldFile.type)
          .split(",")[1]
      );
      let arr = new Uint8Array(binStr.length);
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      let file = new File([arr], oldFile.name, { type: oldFile.type });
      this.$refs.upload.update(oldFile.id, {
        file,
        type: file.type,
        size: file.size,
        active: true
      });
    },
    alert(message) {
      alert(message);
    },
    inputFile(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        this.$nextTick(function() {
          this.edit = true;
        });
      }
      if (!newFile && oldFile) {
        this.edit = false;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert("Your choice is not a picture");
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
    async uploadAvatar() {
      try {
        let formData = new FormData();
        const fileBlob = new Blob([this.files[0].file], {
          type: this.files[0].file.type
        });
        formData.append(this.files[0].name, fileBlob);

        await fetch(`${hostServer}/bucket-upload-handler`, {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.accessToken}`
          }
        });
      } catch (e) {
        //need to notify the user the upload failed
        console.log("it did not work");
        this.files = [{ url: this.user.avatarPath }];
      }
    },
    removeAvatar() {
      this.$confirm("Remove Avatar?", {
        type: "warning"
      }).then(() => {
        const bucketService = feathersClient.service("bucket-upload-handler");
        bucketService
          .remove(null, { query: { fileName: this.user.avatarFileName } })
          .then(res => {
            console.log(res);
            this.files = [];
          });
      });
    },
    numberFormatter(val) {
      return val ? phoneNumberFormatter(val) : val;
    },
    toggleSoftphoneEnabled() {
      const value = !this.softphoneEnabled;
      this.$store.commit("setSoftphoneEnabled", value);
      if (value) {
        this.queryAudioDevices();
      }
    },
    async queryAudioDevices() {
      this.devicesLoading = true;

      try {
        await navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then(stream => {
            stream.getTracks().forEach(track => track.stop());
          });
      } catch (e) {
        console.log("audio permissions blocked");
        this.$notify({
          title: "Warning",
          message: "No Audio Devices Found. Permission is blocked",
          type: "warning"
        });
        this.$store.commit("setSoftphoneEnabled", false);
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then(data => {
          //gather appropriate input devices
          this.inputDevices = data.filter(item => item.kind === "audioinput");

          //if no input devices notify and disable softphone
          if (!this.inputDevices.length) {
            this.$notify({
              title: "Warning",
              message: "No Audio Devices Found. Softphone Is Disabled",
              type: "warning"
            });
            this.$store.commit("setSoftphoneEnabled", false);
            return;
          }

          //devices were reloaded, make sure the device in the store exists/makes sense
          const fromStore = this.audioInputDevice;
          let foundMatch = false;
          for (let i = 0; i < this.inputDevices.length; i++) {
            if (fromStore === this.inputDevices[i].deviceId) {
              foundMatch = true;
              break;
            }
          }

          if (!foundMatch && this.inputDevices.length) {
            console.log("current device is no longer there. set a default");
            this.$store.commit(
              "setAudioInputDeviceId",
              this.inputDevices[0].deviceId
            );
          }

          this.devicesLoading = false;
        })
        .catch(e => {
          this.$notify({
            title: "Warning",
            message: "No Audio Devices Found. Softphone Is Disabled",
            type: "warning"
          });
          this.$store.commit("setSoftphoneEnabled", false);
        });
    },
    changeAudioInput(val) {
      this.$store.commit("setAudioInputDeviceId", val);
    },
  },
  mounted() {
    if (this.user) {
      if (this.user.avatarPath) {
        this.files.push({ url: this.user.avatarPath });
      }
    }
  },
  components: {
    FileUpload
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/variables";

.avatar, .contact-avatar {
  position: relative;
  width: 80px;
  height: 80px;
  cursor: pointer;
  img {
    width: 100%;
    border-radius: 8px;
  }
}

.contact-avatar{
  margin: 0;
  border-radius: 8px;
  .edit-hover{

  }
}

.edit-hover {
  position: absolute;
  left: 2px;
  width: 96%;
  bottom: 0;
  z-index: 1;
}

.remove-hover {
  position: absolute;
  top: 10px !important;
  left: 10px !important;
  z-index: 1;
}

.avatar {
  &:hover {
    .edit-hover {
      opacity: 1;
    }
    .remove-hover {
      opacity: 1;
    }
  }
}

.edit-hover {
  height: 20px;
  width: 76px;
  left: 2px;
  position: absolute;
  display: flex;
  bottom: 2px;
  background: transparentize(#000, 0.6);
  pointer-events: none;
  opacity: 0;
  transition: all 0.5s;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0px 0px 8px 8px;
  color: $text-color-dark;
  font-size: 10pt;
}

.remove-hover {
  width: 20px;
  height: 20px;
  background: transparentize(#000, 0.6);
  position: absolute;
  z-index: 1;
  top: 5px;
  left: 5px;
  opacity: 0;
  transition: all 0.5s;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $text-color-dark;
  font-size: 10pt;
}

.user-info{
  margin-left: 10px;
  font-size: 11pt;
}

.page-profile{
  background: $background-color;
  padding: 5px;
  border-radius: 8px;
}

.avatar-edit {
  .cropper-container {
    max-height: 500px;
  }
  width: 300px;
  background: $background-color;
}

.softphone-toggle{
  position: relative;
  margin-left: auto;
  margin-right: 10px;
}

.dropdown-icon{
  position: absolute;
  z-index: 1;
  right: -5px;
  bottom: 35px;
  border: 2px solid #ccc;
  border-radius: 50%;
  height: 14px;
  width: 14px;
  padding-left: 0.5px;
  background: #f8fafc;
  color: #5a5a5a;
  cursor: pointer;
  svg {
    width: 13px;
    margin-top: -3px;
  }
}

</style>
